import { Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import PageTitle from "../base/PageTitle";
import AddEditTile from "../views/Tile/AddEditTile";

interface Props {}

const TileFormPage: React.FC<Props> = (props) => {
  const { id } = useParams();

  return (
    <Box>
      <PageTitle title={!!id ? `Edit Tile` : "Add New Tile"} />
      <AddEditTile id={+id!} tileType="tile" />
    </Box>
  );
};

export default TileFormPage;
